import { NgModule } from '@angular/core';
// TODO:Spartacus - // TODO:Spartacus - Variable savedCartTranslations has been removed and is no longer part of the public API. 
import { savedCartTranslationChunksConfig, savedCartTranslationsCs } from "@spartacus/cart/saved-cart/assets";
import { CART_SAVED_CART_FEATURE, SavedCartRootModule } from "@spartacus/cart/saved-cart/root";
import { CmsConfig, I18nConfig, provideConfig } from "@spartacus/core";

@NgModule({
  declarations: [],
  imports: [
    SavedCartRootModule
  ],
  providers: [provideConfig(<CmsConfig>{
    featureModules: {
      [CART_SAVED_CART_FEATURE]: {
        module: () =>
          import('@spartacus/cart/saved-cart').then((m) => m.SavedCartModule),
      },
    }
  }),
  provideConfig(<I18nConfig>{
    i18n: {
      resources: savedCartTranslationsCs,
      chunks: savedCartTranslationChunksConfig,
    },
  })
  ]
})
export class CartSavedCartFeatureModule { }
